import React from "react";
import { Redirect, Route } from "react-router-dom";
import {
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import {
  homeOutline,
  timeOutline,
  calendarOutline,
  personOutline,
} from "ionicons/icons";

import Home from "../pages/Home";
import Timesheets from "../pages/Timesheets";
import Planning from "../pages/Planning";
import Profile from "../pages/Profile";
import "./TabLayout.css";
import OrganisationRoute from "@components/OrganisationRoute.tsx";
import { useAuth } from "@/hooks";

const TabLayout: React.FC = () => {
  const { currentOrganisation } = useAuth();

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Redirect exact path="/tabs" to="/tabs/home" />
        <OrganisationRoute exact path="/tabs/home" component={Home} />
        <OrganisationRoute
          exact
          path="/tabs/timesheets"
          component={Timesheets}
        />
        <OrganisationRoute exact path="/tabs/planning" component={Planning} />
        <Route exact path="/tabs/profile" component={Profile} />
      </IonRouterOutlet>

      <IonTabBar slot="bottom" color="primary">
        {currentOrganisation && (
          <IonTabButton tab="home" href="/tabs/home">
            <IonIcon icon={homeOutline} />
            <IonLabel>Home</IonLabel>
          </IonTabButton>
        )}
        {currentOrganisation && (
          <IonTabButton tab="timesheets" href="/tabs/timesheets">
            <IonIcon icon={timeOutline} />
            <IonLabel>Uren</IonLabel>
          </IonTabButton>
        )}
        {currentOrganisation && (
          <IonTabButton tab="planning" href="/tabs/planning">
            <IonIcon icon={calendarOutline} />
            <IonLabel>Planning</IonLabel>
          </IonTabButton>
        )}

        <IonTabButton tab="profile" href="/tabs/profile">
          <IonIcon icon={personOutline} />
          <IonLabel>Profiel</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default TabLayout;
